import { render, staticRenderFns } from "./oneShare.vue?vue&type=template&id=5416e8da&scoped=true"
import script from "./oneShare.vue?vue&type=script&lang=js"
export * from "./oneShare.vue?vue&type=script&lang=js"
import style0 from "./oneShare.vue?vue&type=style&index=0&id=5416e8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416e8da",
  null
  
)

export default component.exports